module.exports = __webpack_public_path__ + "static/img/hbzd.068126e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hbzd.jpg
// module id = XOhX
// module chunks = 1